/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_CalendarIntegrationInfoDto } from '../models/Routemize_DTOs_CalendarIntegrationInfoDto';
import type { Routemize_DTOs_ConnectCalendarToGoogleDto } from '../models/Routemize_DTOs_ConnectCalendarToGoogleDto';
import type { Routemize_DTOs_GoogleCalendarAuthResultDto } from '../models/Routemize_DTOs_GoogleCalendarAuthResultDto';
import type { Routemize_DTOs_GoogleCalendarDto } from '../models/Routemize_DTOs_GoogleCalendarDto';
import type { Routemize_DTOs_GoogleCalendarEventDto } from '../models/Routemize_DTOs_GoogleCalendarEventDto';
import type { Routemize_DTOs_UpdateSyncSettingsDto } from '../models/Routemize_DTOs_UpdateSyncSettingsDto';
import type { System_Net_Http_HttpResponseMessage } from '../models/System_Net_Http_HttpResponseMessage';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GoogleCalendarService {
    /**
     * @returns System_Net_Http_HttpResponseMessage OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarProcessWatch(): CancelablePromise<System_Net_Http_HttpResponseMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/processWatch',
        });
    }
    /**
     * @param returnUrl
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAppGoogleCalendarGetAuthorizationUrl(
        returnUrl?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/googleCalendar/getAuthorizationUrl',
            query: {
                'returnUrl': returnUrl,
            },
        });
    }
    /**
     * @param authCode
     * @param stateCode
     * @returns Routemize_DTOs_GoogleCalendarAuthResultDto OK
     * @throws ApiError
     */
    public static getApiAppGoogleCalendarGetCompleteAuthorization(
        authCode?: string,
        stateCode?: string,
    ): CancelablePromise<Routemize_DTOs_GoogleCalendarAuthResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/googleCalendar/getCompleteAuthorization',
            query: {
                'authCode': authCode,
                'stateCode': stateCode,
            },
        });
    }
    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarIsConnectedToGoogle(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/isConnectedToGoogle',
        });
    }
    /**
     * @param userId
     * @returns boolean OK
     * @throws ApiError
     */
    public static getApiAppGoogleCalendarGetIsConnectedToGoogleByUserId(
        userId: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/googleCalendar/getIsConnectedToGoogleByUserId/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @returns Routemize_DTOs_CalendarIntegrationInfoDto OK
     * @throws ApiError
     */
    public static getApiAppGoogleCalendarGetCalendarIntegrationInfo(): CancelablePromise<Routemize_DTOs_CalendarIntegrationInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/googleCalendar/getCalendarIntegrationInfo',
        });
    }
    /**
     * @returns Routemize_DTOs_GoogleCalendarDto OK
     * @throws ApiError
     */
    public static getApiAppGoogleCalendarGetAvailableGoogleCalendars(): CancelablePromise<Array<Routemize_DTOs_GoogleCalendarDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/googleCalendar/getAvailableGoogleCalendars',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarConnectToGoogleCalendar(
        requestBody?: Routemize_DTOs_ConnectCalendarToGoogleDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/connectToGoogleCalendar',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param calendarId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarDisconnectFromGoogleCalendar(
        calendarId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/disconnectFromGoogleCalendar/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
        });
    }
    /**
     * @param googleAccountEmail
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarRevokeGoogleAccess(
        googleAccountEmail?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/revokeGoogleAccess',
            query: {
                'googleAccountEmail': googleAccountEmail,
            },
        });
    }
    /**
     * @param calendarId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarSynchronizeNow(
        calendarId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/synchronizeNow/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
        });
    }
    /**
     * @param calendarId
     * @param isActive
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarToggleCalendarSyncActiveStatus(
        calendarId: string,
        isActive?: boolean,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/toggleCalendarSyncActiveStatus/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
            query: {
                'isActive': isActive,
            },
        });
    }
    /**
     * @param calendarId
     * @param affectsAvailability
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarSetCalendarAffectsAvailability(
        calendarId: string,
        affectsAvailability?: boolean,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/setCalendarAffectsAvailability/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
            query: {
                'affectsAvailability': affectsAvailability,
            },
        });
    }
    /**
     * @param calendarId
     * @param color
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarSetCalendarColor(
        calendarId: string,
        color?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/setCalendarColor/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
            query: {
                'color': color,
            },
        });
    }
    /**
     * @param calendarId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarSetWriteTargetCalendar(
        calendarId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/setWriteTargetCalendar/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppGoogleCalendarClearWriteTargetCalendar(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/googleCalendar/clearWriteTargetCalendar',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAppGoogleCalendarUpdateSyncSettings(
        requestBody?: Routemize_DTOs_UpdateSyncSettingsDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/googleCalendar/updateSyncSettings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param googleCalendarId
     * @returns Routemize_DTOs_GoogleCalendarEventDto OK
     * @throws ApiError
     */
    public static getApiAppGoogleCalendarGetCalendarEvents(
        googleCalendarId: string,
    ): CancelablePromise<Array<Routemize_DTOs_GoogleCalendarEventDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/googleCalendar/getCalendarEvents/{googleCalendarId}',
            path: {
                'googleCalendarId': googleCalendarId,
            },
        });
    }
    /**
     * @param userId
     * @param startDate
     * @param endDate
     * @returns Routemize_DTOs_GoogleCalendarEventDto OK
     * @throws ApiError
     */
    public static getApiAppGoogleCalendarGetCalendarEventsByUserId(
        userId: string,
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<Array<Routemize_DTOs_GoogleCalendarEventDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/googleCalendar/getCalendarEventsByUserId/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
    /**
     * @param eventId
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppGoogleCalendarDeleteExternalEvent(
        eventId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/googleCalendar/deleteExternalEvent/{eventId}',
            path: {
                'eventId': eventId,
            },
        });
    }
}
